<template>
  <el-button :type="type" :loading="loading" :disabled="disabled" @click="$emit('click')" :title="title" >
    <slot />
  </el-button>
</template>

<script>
export default {
  name: "CommonButton",
  props: {
    type: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    setLoading(loading) {
      this.loading = loading
    },
  },
}
</script>

<style scoped></style>
